export default __webpack_public_path__ + "static/media/calendar.3c99bceb.svg";